import React, { useCallback } from "react";

import Chatbot from "../../../../components/Chatbot";

function OpportunityChatbot({
  value,
  onChange,
  idStep,
  saveStep,
  savingStep,
  error,
  warning,
  validateTree,
  disableChat
}) {
  const handleSave = useCallback(
    saveChatbotConfig =>
      saveStep({
        // Prevent closing current step
        resetEditingStep: false,
        ...saveChatbotConfig
      }),
    [saveStep]
  );
  return (
    <Chatbot
      value={value}
      onChange={onChange}
      error={error}
      warning={warning}
      validateTree={validateTree}
      disableChat={disableChat}
      id={idStep}
      onSave={handleSave}
      loading={savingStep}
    />
  );
}

export default OpportunityChatbot;
